module.exports = __webpack_public_path__ + "img/yancao_haomao_suoluetu.1de705ed.png";